import i18n from "@/i18n";
import useUserStore from "@/store/user";
import * as Sentry from "@sentry/react";
import {AxiosError} from "axios";
import {toast} from "react-toastify";

const getTranslation = (message: string, count?: number) => {
  const isLargeBrand = useUserStore.getState().user.agencies?.at(0)?.agency.large_brand;

  // TODO: rework this after the backend translation messages are updated
  const ERROR_TRANSLATIONS: Record<string, string> = {
    "At least one accepted influencer is required to start campaign": "campaign_start_error_no_accepted_influencers",
    "Campaign application is not in preparation": "application_not_in_preparation",
    "Could not create stripe session": "campaign_start_error_payment_session_not_created",
    "Failed to pay invoice": "invoice_payment_failed_error",
    "Invalid instagram username": "invalid_instagram_username",
    "Invalid tiktok username": "invalid_tiktok_username",
    "Invite already accepted/rejected": "invite_already_accepted_or_rejected",
    "Invite already sent": isLargeBrand ? "large_brand_already_invited" : "agency_already_invited",
    "Invite already sent for agency": isLargeBrand ? "large_brand_already_invited" : "agency_already_invited",
    "Invite already sent for sub brand": "subbrand_already_invited",
    "Invite not found": "invite_not_found",
    "Lade ein gültiges Bild hoch": "image_format_not_supported",
    "Nicht gefunden.": "owner_not_found",
    "No active subscription": "agency_no_active_subscription",
    "Owner not member of any brand passed": "owner_not_brand_member",
    "reason is required": "application_removal_reason_required",
    "Stelle sicher, dass dieser Dateiname höchstens 100 Zeichen lang ist": "filename_too_long",
    "Subscription is required to start campaign": "campaign_start_error_no_subscription",
    "This tiktok username already exists!": "tiktok_user_already_exists",
    "This username already exists!": "instagram_user_already_exists",
    "User already member of agency": isLargeBrand ? "user_already_large_brand_member" : "user_already_agency_member",
    "User already member of an agency": isLargeBrand ? "user_already_large_brand_member" : "user_already_agency_member",
    "User already member of another agency": isLargeBrand
      ? "user_already_large_brand_member"
      : "user_already_agency_member",
    "User already member of sub brand": "user_already_subbrand_member",
    "User already registered": "user_already_registered",
    "User has already applied for this campaign.": "user_already_applied",
    "User is not in the campaign location.": "user_not_in_campaign_location",
    [`You can only accept ${count} influencers per campaign`]: "campaign_start_error_influencer_limit_exceeded",
  } as const;

  const translationKey = Object.keys(ERROR_TRANSLATIONS).find(key => message.includes(key));
  const translatedMessage = !!translationKey
    ? `errors:${ERROR_TRANSLATIONS[translationKey]}`
    : "errors:toast_global_error";

  return i18n.t(translatedMessage, {count});
};

export const captureErrorInSentry = (
  error: AxiosError<{detail?: string | string[]; error?: string | string[]; picture?: string[]}>,
) => {
  const ERROR_KEYS = ["picture", "error", "detail"] as const;

  ERROR_KEYS.map(key => {
    const messages = error.response?.data?.[key];

    if (messages) {
      (messages instanceof Array ? messages : [messages]).map(message =>
        Sentry.captureException(new AxiosError(message)),
      );
    }
  });
};

export const handleErrorWithToast = (
  error: AxiosError<{detail?: string | string[]; error?: string | string[]; picture?: string[]}>,
  count?: number,
) => {
  const ERROR_KEYS = ["picture", "error", "detail"] as const;

  ERROR_KEYS.map(key => {
    const messages = error.response?.data?.[key];

    if (messages) {
      (messages instanceof Array ? messages : [messages]).map(message => toast.error(getTranslation(message, count)));
    }
  });
};
